module.exports = __webpack_public_path__ + "images/51b4853a8838aa7c7e32252aaa24f1f0.png";